import { Section } from "@/components";
import { FC } from "react";
import styles from "../../Treez.module.scss";

function tryParseJsonString(value: string): unknown {
    const trimmed = value.trim();
    if (
        (!trimmed.startsWith("{") || !trimmed.endsWith("}")) &&
        (!trimmed.startsWith("[") || !trimmed.endsWith("]"))
    ) {
        return value;
    }

    try {
        return JSON.parse(trimmed);
    } catch {
        return value;
    }
}

function normalizeRawValue(value: unknown): unknown {
    if (typeof value === "string") {
        const parsed = tryParseJsonString(value);
        if (parsed === value) {
            return value;
        }
        return normalizeRawValue(parsed);
    }

    if (Array.isArray(value)) {
        return value.map(item => normalizeRawValue(item));
    }

    if (value && typeof value === "object") {
        const entries = Object.entries(value as Record<string, unknown>).map(
            ([key, entryValue]) => [key, normalizeRawValue(entryValue)],
        );
        return Object.fromEntries(entries);
    }

    return value;
}

const Raw: FC<IRaw> = ({ object }) => {
    const normalized = normalizeRawValue(object);

    return (
        <Section>
            <div className={styles.rawScroll}>
                <pre className={styles.rawPre}>
                    {JSON.stringify(normalized, null, 2)}
                </pre>
            </div>
        </Section>
    );
};

export default Raw;

interface IRaw {
    object: any;
}
